import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootReducer } from "@twire/redux/types";

import Placeholder from "./Placeholder";
import FantasyTournaments from "./FantasyTournaments";
import { getFantasyTournaments } from "@twire/redux/fantasyTournaments/actions";
import { TournamentStatus } from "../../../FantasyPublicAPI";

const FantasyTournamentsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const {
    fantasyTournaments: { tournaments, requestStates },
  } = useSelector((state: RootReducer) => state);

  useEffect(() => {
    if (tournaments.length === 0) {
      dispatch(getFantasyTournaments());
    }
  }, []);

  return requestStates.tournaments.requesting && tournaments.length === 0 ? (
    <Placeholder />
  ) : (
    <FantasyTournaments
      tournaments={
        tournaments.filter(
          t => t.status === TournamentStatus.LIVE
        )
      }
    />
  );
};

export default FantasyTournamentsContainer;
